(function(){
  'use strict';

  function initReveal(){
    /* Sections — fade up on scroll */
    document.querySelectorAll('.section, .section--cream, .section--white, .section--ivory, .section--dark, .tr, .nl-section').forEach(function(s){
      if(!s.closest('.hero') && !s.classList.contains('hero'))
        s.classList.add('rv');
    });

    /* Section headers */
    document.querySelectorAll('.section-header').forEach(function(el){
      el.classList.add('rv','rv-up');
    });

    /* Product cards — stagger */
    document.querySelectorAll('.prod-card').forEach(function(el,i){
      el.classList.add('rv','rv-up');
      el.style.setProperty('--rv-d', (i % 4) * 0.1 + 's');
    });

    /* Gift guide cards */
    document.querySelectorAll('.gift-card').forEach(function(el,i){
      el.classList.add('rv','rv-up');
      el.style.setProperty('--rv-d', i * 0.1 + 's');
    });

    /* Steps */
    document.querySelectorAll('.step-card').forEach(function(el,i){
      el.classList.add('rv','rv-up');
      el.style.setProperty('--rv-d', i * 0.15 + 's');
    });

    /* FAQ */
    document.querySelectorAll('.faq-item').forEach(function(el,i){
      el.classList.add('rv','rv-up');
      el.style.setProperty('--rv-d', i * 0.06 + 's');
    });

    /* Reviews */
    document.querySelectorAll('.rev-card').forEach(function(el,i){
      el.classList.add('rv','rv-up');
      el.style.setProperty('--rv-d', (i % 4) * 0.1 + 's');
    });

    /* Trust items */
    document.querySelectorAll('.tr-card').forEach(function(el,i){
      el.classList.add('rv','rv-up');
      el.style.setProperty('--rv-d', i * 0.1 + 's');
    });

    /* Newsletter */
    document.querySelectorAll('.nl-inner').forEach(function(el){
      el.classList.add('rv','rv-up');
    });

    /* Video */
    document.querySelectorAll('.vid-main').forEach(function(el){
      el.classList.add('rv','rv-up');
    });

    /* Observe */
    var all = document.querySelectorAll('.rv');
    if('IntersectionObserver' in window && all.length){
      var obs = new IntersectionObserver(function(entries){
        entries.forEach(function(e){
          if(e.isIntersecting){
            e.target.classList.add('rv-show');
            obs.unobserve(e.target);
          }
        });
      },{threshold:0.08,rootMargin:'0px 0px -40px 0px'});
      all.forEach(function(el){obs.observe(el)});
    } else {
      all.forEach(function(el){el.classList.add('rv-show')});
    }
  }

  /* Hero animate-up classes */
  if('IntersectionObserver' in window){
    var ho = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting){e.target.classList.add('is-visible');ho.unobserve(e.target)}
      });
    },{threshold:0.1});
    document.querySelectorAll('.animate-up,.animate-in').forEach(function(el){ho.observe(el)});
  }

  /* Smooth anchor scroll */
  document.querySelectorAll('a[href^="#"]').forEach(function(a){
    a.addEventListener('click',function(e){
      var t=document.querySelector(this.getAttribute('href'));
      if(t){e.preventDefault();t.scrollIntoView({behavior:'smooth',block:'start'})}
    });
  });

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initReveal);
  else initReveal();
})();
